import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'

import Wrapper from '../../components/Wrapper'
import Header from '../../components/Header'
import TopBar from '../../components/TopBar'
import ErrorImage from '../../assets/motor/error_system.png'
import _ from 'lodash'

const fontDefault = {
  fontFamily: 'thonburiregular',
  fontStyle: 'normal',
}

const styles = {}

class ErrorNetwork extends Component {
  backButton = () => {
    const {
      history: { push },
    } = this.props
    const { callbackVersion, currentProduct } = this.props
    if (callbackVersion === 2) {
      if (currentProduct === 'C') {
        push('/select-package')
      } else if (currentProduct === 'V') {
        push('/select-car-model')
      } else {
        push('/home')
      }
    } else {
      push('/home')
    }
  }

  render() {
    return (
      <Wrapper>
        <div style={{ margin: '16px', marginTop: '66px' }}>
          <div
            style={{
              marginTop: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              alt="error_image"
              src={ErrorImage}
              style={{ width: '120px', height: '120px' }}
            />
          </div>
          <p
            style={{
              ...fontDefault,
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: '18px',
              color: '#0e162c',
            }}
          >
            ขออภัย การเชื่อมต่อขัดข้อง
          </p>
          <p
            style={{
              ...fontDefault,
              textAlign: 'center',
              fontSize: '16px',
              color: '#999999',
            }}
          >
            กรุณาทำรายการใหม่อีกครั้ง
          </p>
          <br />

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <button
              style={{
                ...fontDefault,
                color: '#ff8300',
                padding: '7px 20px',
                fontWeight: 'bold',
                border: '1px solid #ff8300',
                borderRadius: '20px',
                backgroundColor: 'white',
              }}
              onClick={this.backButton}
            >
              กลับหน้าหลัก
            </button>
          </div>
        </div>
        <Header>
          <TopBar
            close={() => {
              window.location.replace('ascendmoney://closewebview')
            }}
          />
        </Header>
      </Wrapper>
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    callbackVersion: _.get(state, 'motor.userInput.callbackVersion', 1),
    currentProduct: _.get(state, 'motor.userInput.currentProduct', ''),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ErrorNetwork))
